import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { DrawingManager } from 'react-google-maps/lib/components/drawing/DrawingManager';

import './AreaDrawManager.scss';

class AreaDrawManager extends Component {

    constructor(props) {
        super(props);

        this.handlePolygonComplete = this.handlePolygonComplete.bind(this);
    }

    handlePolygonComplete(polygon) {
        this.props.addNewDraftDeliveryArea(polygon);

        window.google.maps.event.addListener(polygon, 'rightclick', event => {
            this.props.removeDraftDeliveryArea(polygon);
            window.google.maps.event.clearInstanceListeners(polygon);
            polygon.setMap(null);
        });
    }

    render() {
        return (
            <DrawingManager
                defaultOptions={{
                    drawingControl: true,
                    drawingControlOptions: {
                        position: window.google.maps.ControlPosition.TOP_CENTER,
                        drawingModes: [
                            window.google.maps.drawing.OverlayType.POLYGON
                        ],
                    },
                    polygonOptions: {
                        editable: true,
                        draggable: true,
                        geodesic: true
                    }
                }}
                onPolygonComplete={this.handlePolygonComplete}
            />
        );
    }
}

AreaDrawManager.propTypes = {
    addNewDraftDeliveryArea: PropTypes.func,
    removeDraftDeliveryArea: PropTypes.func,
    
};

export default AreaDrawManager;
